import * as React from 'react';
import styled from 'styled-components';

import { GRID_SIZE } from '../global/PaperGrid';

const Wrapper = styled.div`
  display: flex;
  padding: 80px ${GRID_SIZE}px;
  position: relative;

  &.full-width {
    padding-left: 0;
    padding-right: 0;
  }
`;

interface ProductOverviewSectionProps {
  className?: string;
  item: JSX.Element;
}

export const ProductOverviewSection: React.ComponentType<ProductOverviewSectionProps> =
  React.memo(({ item, className }) => {
    return <Wrapper className={className}>{item}</Wrapper>;
  });
